import "./PageProducts.scss";

import Navbar from "../Navbar/Navbar";
import SlidingHeader from "../SlidingHeader/SlidingHeader";
import Footer from "../Footer/Footer";
import ProductContent from "./ProductContent/ProductContent";
function PageProducts() {
  return (
    <>
      <div className="pp-container">
        <SlidingHeader />
        <Navbar />
        <ProductContent />
        <Footer />
      </div>
    </>
  );
}

export default PageProducts;
